import HttpService from '../../services/HttpService';


export default class LicenseService extends HttpService {
  constructor() {
    super('/licenses/api');
  }
}
